<script>
    import { finalNonconformityStore } from "./store.js";
    import { slide } from "svelte/transition";

    export let getData;

    function handleSearch() {
        getData();
    }

    function toggleExpand() {
        finalNonconformityStore.update(s => ({
            ...s,
            search: { ...s.search, isExpanded: !s.search.isExpanded }
        }));
    }
</script>

<div class="search-area">
    {#if $finalNonconformityStore.search.isExpanded}
        <section class="search-panel">
            <div class="search-grid">
                <div class="field">
                    <label>생산계획번호</label>
                    <input type="text" bind:value={$finalNonconformityStore.search.prdctn_plan_no} placeholder="번호 입력" on:keydown={(e) => e.key === 'Enter' && handleSearch()} />
                </div>
                <div class="field">
                    <label>품목코드</label>
                    <input type="text" bind:value={$finalNonconformityStore.search.item_code} placeholder="코드 입력" on:keydown={(e) => e.key === 'Enter' && handleSearch()} />
                </div>
                <div class="field">
                    <label>품목명</label>
                    <input type="text" bind:value={$finalNonconformityStore.search.item_nm} placeholder="품목명 입력" on:keydown={(e) => e.key === 'Enter' && handleSearch()} />
                </div>
                <div class="field">
                    <label>검사자사번</label>
                    <input type="text" bind:value={$finalNonconformityStore.search.inspct_empno} placeholder="사번 입력" on:keydown={(e) => e.key === 'Enter' && handleSearch()} />
                </div>
                <div class="field">
                    <label>검사자명</label>
                    <input type="text" bind:value={$finalNonconformityStore.search.search_korean_nm} placeholder="이름 입력" on:keydown={(e) => e.key === 'Enter' && handleSearch()} />
                </div>
                <div class="field date-range-field">
                    <label>검사일자</label>
                    <div class="date-range-inputs">
                        <input type="date" bind:value={$finalNonconformityStore.search.startDate} />
                        <span>~</span>
                        <input type="date" bind:value={$finalNonconformityStore.search.endDate} />
                    </div>
                </div>
            </div>
            <button class="main-btn" on:click={handleSearch}>데이터 조회하기</button>
        </section>
    {/if}
    
    <div class="toggle-bar" on:click={toggleExpand}>
        <div class="toggle-content">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
                <path d={$finalNonconformityStore.search.isExpanded ? "m18 15-6-6-6 6" : "m6 9 6 6 6-6"} />
            </svg>
            <span>
                {$finalNonconformityStore.search.isExpanded ? "조회 조건 접기" : "조회 조건 펼쳐서 다시 검색하기"}
            </span>
        </div>
    </div>
</div>

<style>
    .search-area {
        flex-shrink: 0;
        background: white;
        border-bottom: 1px solid #e2e8f0;
        padding: 15px 15px 0 15px;
    }
    .search-panel {
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding-bottom: 10px;
    }
    .search-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 10px;
    }
    .field {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }
    .field label {
        font-size: 0.7rem;
        font-weight: 800;
        color: #64748b;
    }
    .date-range-inputs {
        display: flex;
        align-items: center;
        gap: 5px;
    }
    .field input {
        width: 100%;
        height: 35px;
        border: 1.5px solid #e2e8f0;
        border-radius: 4px;
        padding: 0 8px;
        font-size: 0.85rem;
        transition: border-color 0.2s;
    }
    .field input:focus {
        outline: none;
        border-color: #3b82f6;
    }
    .main-btn {
        width: 100%;
        height: 40px;
        background: #3b82f6;
        color: white;
        border: none;
        border-radius: 4px;
        font-weight: 800;
        margin-top: 10px;
        cursor: pointer;
        transition: background 0.2s;
    }
    .main-btn:hover {
        background: #2563eb;
    }
    .toggle-bar {
        padding: 8px 0;
        background: #ffffff;
        cursor: pointer;
        display: flex;
        justify-content: center;
        border-top: 1px solid #f1f5f9;
    }
    .toggle-content {
        display: flex;
        align-items: center;
        gap: 8px;
        color: #3b82f6;
        font-size: 0.85rem;
        font-weight: 800;
    }

    @media (max-width: 768px) {
        .search-grid {
            grid-template-columns: repeat(2, 1fr);
        }
    }
</style>
